package org.zq.astrock_ai.ui.research.gushi.model

enum class TrendDirection {
    UP,
    DOWN,
    FLAT
}

data class StockItem(
    val name: String,
    val code: String,
    val marketCode: String,
    val price: String,
    val changeAmount: String,
    val changePercent: String,
    val direction: TrendDirection,
    val status: String,
    val note: String,
    val industry: String,
    val tags: List<String>,
    val sparkline: List<Float>
)

data class Candle(
    val open: Double,
    val high: Double,
    val low: Double,
    val close: Double,
    val volume: Double,
    val date: String = "",
    val avg: Double? = null,
)

enum class NewsType {
    NEWS,
    CAPITAL,
    ANNOUNCEMENT,
    FINANCIAL,
    RESEARCH
}

data class NewsItem(
    val time: String,
    val type: NewsType,
    val title: String,
    val source: String,
    val impact: String,
    val url: String = "",
)

data class ChatMessage(
    val isUser: Boolean,
    val text: String,
    val time: String,
)

/** 用户持仓（按股票代码索引） */
data class HoldingPosition(
    val stockCode: String,
    val stockName: String,
    val costPrice: Double,
    val quantity: Int,
    /** 现价触及或跌破该价时提醒（可选） */
    val alertPrice: Double? = null,
    /** 浮盈亏达到该百分比（可负）时提醒，如 -5 表示亏 5% */
    val alertPnlPct: Double? = null,
) {
    val marketValueHint: Double get() = costPrice * quantity
}

/** K 线回测买卖点标记 */
data class ChartTradeMarker(
    val date: String,
    val price: Double,
    val side: String, // BUY / SELL
)

/** 荐股落点：图上圆点，点击看推荐价与相对现价盈亏 */
data class ChartRecommendMarker(
    val atMs: Long,
    val price: Double,
    val dateLabel: String = "",
)
